import {
  DOMAIN,
  PERMISSION,
  useCanManageJobPostsBool,
  useCanViewCareerPlanBool,
  useCanViewCareerPreferencesBool,
  useHasCapabilityBool
} from "@/hooks/useCapabilities";
import { useFlags } from "@/hooks/useFeatureFlags";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useCanAccessCareerOverview } from "./_hooks/useCanAccessCareerOverview";

export default function CareerIndex() {
  const { pgaId } = useParams();
  const location = useLocation();
  const base = location.pathname.replace(/\/$/, "");
  const showOverview = useCanAccessCareerOverview();
  const flags = useFlags();
  const careerTargetsEnabled = flags["pga-career-targets"] === true;
  const canViewPersonCareer = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonCareer
  });
  const canViewCareerPlan = useCanViewCareerPlanBool();
  const canViewCareerPreferences = useCanViewCareerPreferencesBool();
  const canViewCompensationProfiles = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewCompensationProfiles
  });
  const canManageJobPosts = useCanManageJobPostsBool();
  const canViewJobPostings = useHasCapabilityBool({
    domain: DOMAIN.JOBS,
    permission: PERMISSION.viewJobPosts
  });

  if (!pgaId) return null;

  const firstTab = [
    showOverview && "overview",
    canViewPersonCareer && "employment",
    careerTargetsEnabled && canViewCareerPlan && "career-profile",
    canManageJobPosts && "job-applications",
    canViewCareerPreferences && "job-preferences",
    canViewCompensationProfiles && "compensation",
    canViewJobPostings && "job-postings"
  ].find(Boolean);

  if (!firstTab) {
    return <Navigate to={`/people/${pgaId}/person/overview`} replace />;
  }

  return <Navigate to={`${base}/${firstTab}`} replace />;
}
